import { readPlayerProgression, createPlayerProgression, doProgressionExists, updatePlayerProgression, increaseConnection } from "../utils/callAPI.js";

let instance = null;

export default class SauvegardeManager {
    constructor() {
        if(instance !== null){
            return instance
        }

        instance = this;
        this.sauvegarde = {
            login: "",
            progression: {
                // currentChapitre: "Chapitre1",
                //TODO : definir la structure de la sauvegarde
            }
        };
    }

    // -- Gestion de la sauvegarde locale

    setLogin(login) {
        this.sauvegarde.login = login;
    }

    updateProgression(chapitre, info) {
        if(!this.sauvegarde.progression[chapitre]){
            this.sauvegarde.progression[chapitre] = {};
        }

        this.sauvegarde.progression[chapitre] = info;

        this.saveOnDatabase();
    }

    getChapitreProgression(chapitre) {
        return this.sauvegarde.progression[chapitre];
    }

    setCurrentChapter(chapter){
        this.sauvegarde.progression.currentChapitre = chapter
    }

    getCurrentChapter() {
        return this.sauvegarde.progression.currentChapitre;
    }

    // -- Gestion de la sauvegarde avec le backend

    doPlayerExistsOnDatabase(endFunc) {
        doProgressionExists(this.sauvegarde.login, (exists) => {
            console.log("Player exists :", exists);
            if(endFunc) endFunc(exists);
        });
    }

    loadFromDatabase(endFunc) {
        readPlayerProgression(this.sauvegarde.login, (data) => {
            this.sauvegarde = data[0] || {};
            this.sauvegarde.progression = JSON.parse(this.sauvegarde.progression);
            console.log("Sauvegarde loaded from database :", this.sauvegarde);
            if(endFunc) endFunc();
        });
    }

    createOnDatabase() {
        createPlayerProgression(this.sauvegarde.login, this.sauvegarde.progression);
    }

    saveOnDatabase(){
        updatePlayerProgression(this.sauvegarde.login, this.sauvegarde.progression);  
    }

    increaseNumberOfConnections(){
        increaseConnection(this.sauvegarde.login);  
    }
}